"use strict";

import React from "react";
import { Button } from "@showitinc/showit-wc";
import InputControl from "../base/InputControl";
import InputSanitizer from "../../utils/InputSanitizer";
import { toUnicode } from "../../utils/DomainUtils";
const containsShowit = InputSanitizer.containsShowit;

class SubdomainNameUpdateForm extends React.Component {
  static defaultProps = {
    submitting: false,
    error: null,
    updateMode: false,
  };

  constructor(props) {
    super(props);
    let name = "";
    if (props.name) {
      name = props.name;
    }

    this.state = {
      name: name,
      error: null,
    };
  }

  _submit = () => {
    const name = this.state.name;
    const primaryDomain = this.props.primaryDomain;

    if (containsShowit(name)) {
      return this.setState({ error: "Please do not use Showit in your subdomain." });
    }

    if (this.props.onNameUpdate) {
      this.props.onNameUpdate({ web_name: name, parent_site_id: primaryDomain.site_id });
    }
  };

  _onNameChange = (e) => {
    let value = e.target.value;
    if (value) {
      value = value.toLowerCase().trim();
      value = value.replace(/[^a-z0-9-]+/gi, "");
      value = value.replace("www.", "");
    }

    this.setState({ name: value });
  };

  render() {
    const primaryDomain = this.props.primaryDomain;
    const error = this.props.error || this.state.error;
    let errorMessage = null;

    if (error) {
      errorMessage = (
        <div className={"has-error"} style={{ marginBottom: "1rem" }}>
          <div className={"help-block"}>{error.message || error}</div>
        </div>
      );
    }

    let btns = null;

    if (this.props.updateMode) {
      btns = (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button onClick={this._submit} variant="feature" disabled={this.props.submitting}>
            Update
          </Button>
        </div>
      );
    } else {
      btns = (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button onClick={this.props.onCancel} variant="minimal" disabled={this.props.submitting}>
            Cancel
          </Button>
          <span>&nbsp;&nbsp;&nbsp;</span>
          <Button
            onClick={this._submit}
            variant="feature"
            disabled={this.props.submitting}
            data-testid="subdomain-add-button"
          >
            Add
          </Button>
        </div>
      );
    }

    return (
      <div>
        {errorMessage}
        <div
          className={"form-wide"}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "baseline",
            color: "var(--text-base-secondary)",
            marginBottom: "12px",
          }}
        >
          <span>http://&nbsp;</span>
          <InputControl
            type="text"
            name="subdomainName"
            data-testid="subdomain-name-field"
            placeholder="+Site Name"
            value={this.state.name}
            onChange={this._onNameChange}
          />
          <span>&nbsp;.{toUnicode(primaryDomain?.domain_name || "")}</span>
        </div>
        {btns}
      </div>
    );
  }
}

export default SubdomainNameUpdateForm;
